import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";

export interface DialogResetLayoutProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DialogResetLayoutsComponent: React.FC<DialogResetLayoutProps> = ({
  open,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={() => onCancel()} fullWidth maxWidth={"sm"}>
      <DialogTitle>{t("ResetLayoutsTitle")}</DialogTitle>
      <DialogContent sx={{ alignItems: "flex-start" }}>
        <List>
          <ListItem>
            <span>1. {t("FirstPointResetLayouts")}</span>
          </ListItem>
          <ListItem>
            <span>2. {t("SecondPointResetLayouts")}</span>
          </ListItem>
        </List>
        <Typography variant="caption" color="error">
          {t("ResetLayoutsWarning")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="success" variant="contained" onClick={() => onConfirm()}>
          {t("Submit")}
        </Button>
        <Button color="error" variant="contained" onClick={() => onCancel()}>
          {t("Cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogResetLayoutsComponent;
